export { buildAppointmentNoteResult, APPOINTMENT_NOTE_SYSTEM_USER } from './appointment-notes.util';
